// AuthLayout.js

import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "../components/ui";
import { ArrowLeftIcon } from "../components/ui/icons";

// Auth screens are full-bleed split layouts, so they get no navbar — but they
// must still offer a way back to the site.
const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-bg">
      <div className="flex items-center justify-between px-4 py-4 md:px-6 lg:px-8">
        <Logo />
        <Link
          to="/"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-muted transition-colors hover:text-navy"
        >
          <ArrowLeftIcon className="h-4 w-4" />
          Back to site
        </Link>
      </div>
      {children}
    </div>
  );
};

export default AuthLayout;
